"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Flex } from "@styled-system/jsx";
import { CheckCircle, X, XCircle } from "lucide-react";
import { Paragraph } from "@/components/primitives/typography";
import { alertPopupRecipe } from "@/styles/alertPopup.style";
type AlertPopupProps = {
  message: string;
  isOpen?: boolean;
  onClose?: () => void;
  autoCloseTime?: number;
  success?: boolean;
};
export const AlertPopup = t0 => {
  const $ = _c(33);
  const {
    message,
    isOpen: t1,
    onClose,
    autoCloseTime: t2,
    success: t3
  } = t0;
  const isOpen = t1 === undefined ? true : t1;
  const autoCloseTime = t2 === undefined ? 5000 : t2;
  const success = t3 === undefined ? false : t3;
  const [isVisible, setIsVisible] = useState(isOpen);
  const t4 = success ? "success" : "error";
  let t5;
  if ($[0] !== t4) {
    t5 = alertPopupRecipe({
      type: t4
    });
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const styles = t5;
  let t6;
  let t7;
  if ($[2] !== isOpen) {
    t6 = () => {
      setIsVisible(isOpen);
    };
    t7 = [isOpen];
    $[2] = isOpen;
    $[3] = t6;
    $[4] = t7;
  } else {
    t6 = $[3];
    t7 = $[4];
  }
  useEffect(t6, t7);
  let t8;
  if ($[5] !== autoCloseTime || $[6] !== isVisible) {
    t8 = [isVisible, autoCloseTime];
    $[5] = autoCloseTime;
    $[6] = isVisible;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  useEffect(() => {
    if (isVisible && autoCloseTime > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, autoCloseTime);
      return () => clearTimeout(timer);
    }
  }, t8);
  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };
  if (!isVisible) {
    return null;
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      padding: "20px",
      width: "100%"
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== success) {
    t10 = success ? <CheckCircle /> : <XCircle />;
    $[9] = success;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== styles.icon || $[12] !== t10) {
    t11 = <Flex className={styles.icon}>{t10}</Flex>;
    $[11] = styles.icon;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      width: "100%"
    };
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== message) {
    t13 = message.includes(" - ") ? <><b>{message.split(" - ")[0]}</b>{message.split(" - ")[1] ? ` - ${message.split(" - ")[1]}` : null}</> : <>{message}</>;
    $[15] = message;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== styles.message || $[18] !== t13) {
    t14 = <Paragraph size="compact" className={styles.message}>{t13}</Paragraph>;
    $[17] = styles.message;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== handleClose || $[21] !== styles.closeButton) {
    t15 = <X size={16} className={styles.closeButton} onClick={handleClose} />;
    $[20] = handleClose;
    $[21] = styles.closeButton;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14 || $[24] !== t15) {
    t16 = <Flex justify="space-between" align="center" style={t12}>{t14}{t15}</Flex>;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== styles.container || $[27] !== t11 || $[28] !== t16) {
    t17 = <Flex className={styles.container} justify="space-between" align="center" style={t9}>{t11}{t16}</Flex>;
    $[26] = styles.container;
    $[27] = t11;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== styles.root || $[31] !== t17) {
    t18 = <Flex className={styles.root}>{t17}</Flex>;
    $[30] = styles.root;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  return t18;
};